import { dark as theme } from "~/ui-rtk/themes/dark.js"

export default function useTailwindTheme() {
  return theme
}
